import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Ship } from '@classes/ship';
import { ShipDetail } from '@classes/ship-detail';
import { ShipService } from 'app/core/services/ship.service';
import { ShipDetailComponent } from 'app/modules/repository/components/ship-detail/ship-detail.component';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-ship-list',
  templateUrl: './ship-list.component.html',
  styleUrls: ['./ship-list.component.scss']
})
export class ShipListComponent implements OnInit {

  @Input() set control(ctr: FormControl | null) {
    if (ctr) {
      this.myControl = ctr;
      this._initFilteredShips();
    }
  }
  @Input() placeHolder: string;
  @Input() pacoOnly: boolean = false;
  @Input() displayAddButton: boolean = false;

  myControl!: FormControl;

  ships: Ship[] = [];
  filteredShips: Observable<Ship[]> | undefined;

  constructor(
    public shipService: ShipService,
    public dialog: MatDialog
  ) {
    this._initList();
  }

  ngOnInit() {
    this._refreshList();
  }

  private _initList(refresh?: boolean) {
    this.shipService.ships.subscribe(ships => {
      this.ships = ships
        .sort((a, b) => ((a.name || "").toLowerCase() > (b.name || "").toLowerCase()) ? 1 : (((b.name || "").toLowerCase() > (a.name || "").toLowerCase()) ? -1 : 0));;
      this._initFilteredShips();
    }, error => {
      console.error(error);
    });

  }

  private _refreshList() {
    this.shipService.getShips(true).subscribe();
  }

  private _initFilteredShips(): void {
    if (this.myControl) {
      this.filteredShips = this.myControl.valueChanges
        .pipe(
          startWith(''),
          map(value => {
            if (typeof value === 'string') {
              return this._filter(value);
            }
            return []
          })
        );
    }
  }

  private _filter(value: string): Ship[] {
    const filterValue = value.toLowerCase();
    return this.ships.filter(option =>
      (option.name || '').toLowerCase().includes(filterValue)
      || (option.eni || '').toLowerCase().includes(filterValue)
    );
  }

  displayFn(ship?: Ship): string {
    return ship ? (ship.name || '') : '';
  }

  createShip() {
    const data = new ShipDetail({
      isCreationMode: true
    });
    const dialogRef = this.dialog.open(ShipDetailComponent, {
      data,
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(value => {
      if (value && value.success) {
        this._refreshList();
        this.myControl.setValue(value.data);
      }
    });
  }

}
